export default function (dataContent, filename) {
  let mimeType = 'text/csv;encoding:utf-8'
  let fileName = filename || 'data.txt'
  let content = dataContent

  let a = document.createElement('a')
  mimeType = mimeType || 'application/octet-stream'

  if (navigator.msSaveBlob) {
    // IE10
    navigator.msSaveBlob(new window.Blob([content], {
      type: mimeType
    }), fileName)
  } else if (window.URL && 'download' in a) {
    // html5 A[download]
    a.href = window.URL.createObjectURL(new window.Blob([content], {
      type: mimeType
    }))
    a.setAttribute('download', fileName)
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  } else {
    window.location.href = 'data:application/octet-stream,' + encodeURIComponent(content) // only this mime type is supported
  }
}



// WEBPACK FOOTER //
// ./src/components/live-player/components/modules/dataOutput.js